import React from 'react';
import TooltipC from '../../atoms/tooltip/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';
import { TABLE_FORMATS } from './constants';
import { MessageCircle } from 'lucide-react';

const TableCellContent = ({ item, dataKey, idx, formats, formattingOptions, tableId }) => {
    const formatConfig = formats[dataKey];
    const value = item[dataKey];

    if (!formatConfig) {
        return (
            <div className="table-cell-container">
                <div className="table-cell-text">{lang('es', value)}</div>
            </div>
        );
    }

    const { type, children, path, prefix, id, key: configKey } = formatConfig;

    const renderChildren = () => {
        if (!children) return null;
        return (
            <div className="table-child">
                {typeof children === "function"
                    ? children(item, idx)
                    : React.cloneElement(children, {
                        id: `input-${idx}-${dataKey}`,
                        data: item,
                        index: idx
                    })}
            </div>
        );
    };

    const formatters = {
        [TABLE_FORMATS.MONEY]: () => formattingOptions.money(value, dataKey),
        [TABLE_FORMATS.UNIT]: () => formattingOptions.unit(value, dataKey),
        [TABLE_FORMATS.JSON_PATH]: () => formattingOptions.json_path(value, path),
        [TABLE_FORMATS.TIMESTAMP]: () => formattingOptions.timestamp(value, dataKey),
        [TABLE_FORMATS.PREFIX]: () => formattingOptions.prefix(prefix, value),
        [TABLE_FORMATS.BOOLEAN]: () => formattingOptions.boolean(value, dataKey),
        [TABLE_FORMATS.PERCENTAGE]: () => formattingOptions.percentage(value, dataKey),
        [TABLE_FORMATS.FORMAT]: () => formattingOptions.format(value, dataKey),
        [TABLE_FORMATS.INPUT]: () => (
            <input
                id={id ? item[id] : idx}
                className='table-input-format'
                type="text"
                name={configKey}
                defaultValue={value}
                onChange={(e) => dispatchCustomEvent(`table-${tableId}-input-change`, e)}
                onClick={(e) => e.stopPropagation()}
            />
        ),
        [TABLE_FORMATS.TOOLTIP]: () => (
            <TooltipC text={value}>{value}</TooltipC>
        ),
        [TABLE_FORMATS.ICON_TOOLTIP]: () => {
            if (!value) return <span className="table-cell-empty">—</span>;
            return (
                <TooltipC text={value}>
                    <span className="table-icon-tooltip">
                        <MessageCircle size={16} />
                    </span>
                </TooltipC>
            );
        },
        [TABLE_FORMATS.CHIP]: () => {
            const label = formattingOptions.unit
                ? formattingOptions.unit(value, dataKey)
                : value;
            if (!label) return <span className="table-cell-empty">—</span>;
            return (
                <span className="table-chip">
                    {label}
                </span>
            );
        },
        [TABLE_FORMATS.CUSTOM]: () => null
    };

    const isCustom = type === TABLE_FORMATS.CUSTOM;

    return (
        <div className="table-cell-container">
            {renderChildren()}
            {!isCustom && (
                <div className="table-cell-value">
                    {formatters[type] ? formatters[type]() : lang('es', value)}
                </div>
            )}
        </div>
    );
};

export default React.memo(TableCellContent);
